import { BasePage } from '@/components/ui/base-page'
import { 
  AssetManagementPage,
  DistressedREPage, 
  FranchisePage,
  LendingPage,
  EquityInsurancePage,
  InstitutionalBankingPage,
  RSUPage,
  WealthPage,
  PortfolioPage,
  RealEstatePage,
  LifeInsurancePage
} from '@/pages/services/financial'
import { Routes, Route } from 'react-router-dom'

export function InvestmentServicesPage() {
  return (
    <BasePage
      title="Investment Services"
      description="Financial services and solutions"
    >
      <Routes>
        <Route path="banking" element={<InstitutionalBankingPage />} />
        <Route path="insurance" element={<LifeInsurancePage />} />
        <Route path="portfolio" element={<PortfolioPage />} />
        <Route path="wealth" element={<WealthPage />} />
        <Route path="rsu" element={<RSUPage />} />
        <Route path="equity-insurance" element={<EquityInsurancePage />} />
        <Route path="equity-lending" element={<LendingPage />} />
        <Route path="real-estate" element={<RealEstatePage />} />
        <Route path="franchises" element={<FranchisePage />} />
        <Route path="distressed" element={<DistressedREPage />} />
        <Route path="asset-management" element={<AssetManagementPage />} />
      </Routes>
    </BasePage>
  )
}